const uiConfig = [
  {
    item: 'sidebar',
    items: [
      { label: "Home", code: "HHM" },
      { label: "Sign-in", code: "HSS" },
      { label: "Communication", code: "HCM" },
      { label: "Inbox", code: "HIB" },
      { label: "Onboard", code: "HON" },
      { label: "Patient", code: "HPT" },
      { label: "RPM", code: "HRM" },
      { label: "User", code: "HUS" },
      { label: "Waiting Room", code: "HWR" },
      { label: "Reports", code: "HRP" },
      { label: "Tasks", code: "HTK" },
      { label: "Scheduler", code: "HSC" },
      { label: "Inventory", code: "HIN" },
      { label: "CareIq", code: "HCI" },
      { label: "Colour Coding", code: "HCC" },
      { label: "Logout", code: "HLO" },
       { label: "Support", code: "SUP" },
    ],
  },
  {
item:'header',
items:[]

  }
];

export default uiConfig;
